import { LightningElement, wire } from "lwc";
import { LabelTranslations, MultiLabelAdapter } from "tbme/localization";
import { sharedUrls } from "../localState/urls";
import { REQUEST_LEAVE_SITE_MODAL_EVENT } from "./requestLeaveSite";

export default class extends LightningElement {
  private displayModal = false;
  private pendingUrl: string | null = null;
  private labels: LabelTranslations = undefined!;

  private _handleRequestLeaveSite = (e: CustomEvent<{ href: string }>) => {
    this.pendingUrl = e.detail?.href ?? null;
    this.displayModal = true;
  };

  get headline(): string {
    return this.labels?.leaveSiteModalHeadline ?? "";
  }

  get message(): string {
    return this.labels?.leaveSiteModalMessage ?? "";
  }

  get continueLabel(): string {
    return this.labels?.leaveSiteModalContinue ?? "";
  }

  get cancelLabel(): string {
    return this.labels?.leaveSiteModalCancel ?? "";
  }

  get logoUrl(): string {
    return sharedUrls.leaveSiteModalLogo();
  }

  connectedCallback() {
    document.addEventListener(
      REQUEST_LEAVE_SITE_MODAL_EVENT,
      this._handleRequestLeaveSite as EventListener
    );
  }

  disconnectedCallback() {
    try {
      if (document && typeof document.removeEventListener === "function") {
        document.removeEventListener(
          REQUEST_LEAVE_SITE_MODAL_EVENT,
          this._handleRequestLeaveSite as EventListener
        );
      }
    } catch (_) {
      // Ignore during Jest teardown when document may be null
    }
  }

  handleConfirm() {
    if (this.pendingUrl) {
      window.open(this.pendingUrl, "_blank", "noopener,noreferrer");
    }
    this.displayModal = false;
    this.pendingUrl = null;
  }

  handleRequestClose() {
    this.displayModal = false;
    this.pendingUrl = null;
  }

  @wire(MultiLabelAdapter, {
    labels: [
      "userDetails.leaveSiteModalHeadline",
      "userDetails.leaveSiteModalMessage",
      "userDetails.leaveSiteModalCancel",
      "userDetails.leaveSiteModalContinue",
    ],
  })
  private handleLabels({
    userDetails,
  }: {
    userDetails: LabelTranslations;
  }) {
    if (userDetails) {
      this.labels = userDetails;
    }
  }
}
